<template>
  <a href="javascript:;">
    <ant-icon v-if="loading" type="LoadingOutlined"></ant-icon>
    <slot v-else></slot>
  </a>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  isGlobal: true,
  name: "HmdEmptyLink",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
